import { CardElementData } from '@adyen/adyen-web/dist/types/components/Card/types';
import { PaymentAction } from '@adyen/adyen-web/dist/types/types';
import CardEntry from '../components/CardEntry';
import CardVerification from './CardVerification';
import AdyenCore from '@adyen/adyen-web/dist/types/core';

export default function CardHandler({
  threeDSData,
  handleCardData,
  adyenSdk,
  setBinValue,
}: {
  threeDSData: PaymentAction | null;
  handleCardData: (data: CardElementData) => void;
  adyenSdk: AdyenCore;
  setBinValue?: (bin: string) => void;
}): JSX.Element {
  return threeDSData ? (
    <CardVerification data={threeDSData} adyenSdk={adyenSdk} />
  ) : (
    <CardEntry setCardData={handleCardData} adyenSdk={adyenSdk} setBinValue={setBinValue} />
  );
}
